export default __webpack_public_path__ + "static/media/truck_in_route.2df2760a.svg";